// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rj-0";